const convertDateTimeToPattern = (date: Date) => {
  // const { getMonth, getDay, getFullYear, getHours, getMinutes } = date;

  return `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
};

export default convertDateTimeToPattern;
